import React from 'react';
import { useChat } from '../contexts/ChatContext';
import './ErrorDisplay.css';

interface ErrorDisplayProps {
  error: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => {
  const { dispatch } = useChat();

  const handleDismiss = () => {
    dispatch({ type: 'SET_ERROR', payload: null });
  };

  const handleRetry = () => {
    dispatch({ type: 'SET_ERROR', payload: null });
    // 可以在这里添加重试逻辑
  };

  return (
    <div className="error-display">
      <div className="error-content">
        <div className="error-icon">⚠️</div>
        <div className="error-message">
          <h4>出现错误</h4>
          <p>{error}</p>
        </div>
        <div className="error-actions">
          <button onClick={handleRetry} className="retry-button">
            重试
          </button>
          <button onClick={handleDismiss} className="dismiss-button">
            关闭
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay; 